import React from "react";

function Footer() {
    return (
        <div className="footer">
            <footer class="py-5 bg-dark fixed-bottom">
                <div class="container">
                    <p class="m-0 text-center text-white">
                        Copyright &copy; <a class="url" href="https://github.com/TeppeiTeranishi" target="blank">Ademir Candelario</a> 
                    </p>
                </div>
            </footer>
        </div>
    );
}

export default Footer